/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FundOwnershipCapTableDetailsModel } from './FundOwnershipCapTableDetailsModel';
import type { SecurityRead } from './SecurityRead';
export type CapTableDetailsModel = {
  readonly id?: number;
  readonly securities?: Array<SecurityRead>;
  fund_ownership?: FundOwnershipCapTableDetailsModel;
  sheet_attribute_mapping: number;
  readonly cell_annotations?: Record<string, Record<string, {
    row_mode?: 'single_cell' | 'single_row' | 'multi_row';
    columns_config?: Array<any>;
    rows?: Array<{
      position?: number;
      value?: string | null;
      metadata?: any;
    }>;
  }>>;
  readonly has_unconfigured_custom_breakpoints?: boolean;
  readonly cfl_totals_by_fund?: any;
  readonly cfl_totals_by_fund_security?: any;
  readonly created_at?: string;
  readonly updated_at?: string;
  name: string;
  readonly last_audit_event_id?: string | null;
  slug?: string;
  is_deleted?: boolean | null;
  readonly deleted_at?: string | null;
  shares_outstanding?: string | null;
  shares_diluted?: string | null;
  current_own_percent?: string | null;
  diluted_own_percent?: string | null;
  initial_liquidation_preference?: string | null;
  is_primary?: boolean;
  waterfall_breakpoints?: any;
  incremental_distribution?: any;
  distribution_percent?: any;
  use_custom_breakpoints?: boolean;
  custom_breakpoints?: any;
  has_liquidation_preference_ledger?: boolean;
  has_dividend_rate_ledger?: boolean;
  is_waterfall_visible?: boolean;
  access_level?: CapTableDetailsModel.access_level;
  created_by?: number | null;
  company_measurement_date?: number | null;
};
export namespace CapTableDetailsModel {
  export enum access_level {
    COLLABORATIVE = 'collaborative',
    RESTRICTED = 'restricted',
    PRIVATE = 'private',
  }
}

